export const hobbyData = [
  {
    id: 'cooking',
    name: 'Cooking',
    theme: '#f97316',
    category: 'Recipes',
    description: 'Save recipes, ingredients, and imported cooking ideas.',
  },
  {
    id: 'movies',
    name: 'Movies',
    theme: '#8b5cf6',
    category: 'Watchlist',
    description: 'Track movies you want to watch, are watching, or finished.',
  },
  {
    id: 'tvshows',
    name: 'TV Shows',
    theme: '#2563eb',
    category: 'Series',
    description: 'Keep show status and recommendations in one tidy place.',
  },
  {
    id: 'reading',
    name: 'Reading',
    theme: '#0891b2',
    category: 'Library',
    description: 'Manage books, authors, and reading progress.',
  },
  {
    id: 'traveling',
    name: 'Traveling',
    theme: '#16a34a',
    category: 'Trips',
    description: 'Plan destinations, dates, and trip status.',
  },
  {
    id: 'fitness',
    name: 'Fitness',
    theme: '#14b8a6',
    category: 'Fitness',
    description: 'Plan structured sessions, log activities, and track progress.',
  },
  {
    id: 'hiking',
    name: 'Hiking',
    theme: '#84cc16',
    category: 'Trails',
    description: 'Track local hikes, trail details, difficulty, and trip-linked adventures.',
  },
  { id: 'music', name: 'Music Moments', theme: '#db2777', category: 'Moments', description: 'Remember what you played, sang, or created.' },
  { id: 'creative', name: 'Creative Projects', theme: '#a855f7', category: 'Projects', description: 'Save ideas, make progress, and celebrate what you create.' },
  { id: 'dining', name: 'Dining', theme: '#c58b24', category: 'Places', description: 'Save places, remember what you tried, and revisit your favorites.' },
];

export const hobbiesOverviewStrings = {
  eyebrow: 'Hobbies',
  title: 'Choose a module',
  detail: 'Open a focused space for the hobby you want to plan, log, or revisit.',
};
